import { acceptedRedirectHosts } from '@gonfalon/dogfood-flags/dogfood-flags';

export function getIsValidRedirectPath(redirectPath: string) {
  if (!redirectPath || redirectPath.trim() === '') {
    return false;
  }

  let url: URL | undefined;
  try {
    url = new URL(redirectPath);
  } catch {
    try {
      url = new URL(redirectPath, window.location.origin);
    } catch {
      return false;
    }
  }

  const redirectHosts = acceptedRedirectHosts() || [];
  const accepted = [window.location.host, ...redirectHosts];
  const allowedProtocols = ['https:', 'http:'];
  return accepted.includes(url.host) && allowedProtocols.includes(url.protocol);
}
